export const formatDateTimeStr = (dateTime: string) => {
  const day = dateTime.slice(8, 10);
  const month = dateTime.slice(5, 7);
  const year = dateTime.slice(0, 4);
  const hour = dateTime.slice(11, 13);
  const minute = dateTime.slice(14, 16);

  return `${day}/${month}/${year} ${hour}:${minute}`;
};
